import { useEffect, useState } from 'react';
import { Empty, Radio, Tooltip } from 'antd';
import { observer } from 'mobx-react';
import { getSubjectLecturers, LecturerBlocksProps } from '@modules/timetable';
import { useMst } from '@models/Root';
import { subjects_for_timetableQuery } from '@app-types/graphql-types';

export const LecturerBlocks = observer(({ batchSubjects }: LecturerBlocksProps) => {
  const [subjectLecturers, setSubjectLecturers] = useState<
    subjects_for_timetableQuery['batch_subject_configuration'][0]['subject']['subject_to_users'] | undefined
  >([]);
  const { selectedTimelineItem, selectedDraggableItem, setSelectedLecturer, selectedLecturer } = useMst().timetable;

  // Filter selected subject and get subject lecturers
  useEffect(() => {
    setSubjectLecturers(
      getSubjectLecturers({
        selectedDraggableItem,
        batchSubjects,
        timelineItemId: selectedTimelineItem?.elementID,
        itemType: selectedTimelineItem?.itemType,
      }),
    );

    // Select first lecturer default on selected subject change
    if (subjectLecturers && !selectedTimelineItem?.lecturerID) {
      setSelectedLecturer(subjectLecturers[0]?.user?.id);
    }
  }, [selectedDraggableItem, batchSubjects, selectedTimelineItem, setSelectedLecturer, subjectLecturers]);

  if (!selectedDraggableItem && !selectedTimelineItem) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Select a subject first" />;
  }

  return (
    <Radio.Group onChange={(event) => setSelectedLecturer(event.target.value)} value={selectedLecturer}>
      {subjectLecturers?.map((lecturer) => (
        <Tooltip placement="topLeft" key={lecturer.user.id} title={lecturer.user.employeeID}>
          <Radio className="radio-button" value={lecturer.user.id}>
            {`${lecturer.user.firstName} ${lecturer.user.lastName}`}
          </Radio>
        </Tooltip>
      ))}
    </Radio.Group>
  );
});
